import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import * as React from 'react';

/**
 * A drop-in replacement for the old `KeyboardDatePicker` from @material-ui/pickers`.
 * Keeps all existing logic and event behavior intact.
 * Internally uses MUI v5's DatePicker.
 */
const KeyboardDatePicker = (props) => {
  const {
    value,
    onChange,
    format,
    label,
    variant,
    margin,
    fullWidth,
    required,
    error,
    helperText,
    KeyboardButtonProps,
    disableToolbar,
    minDate,
    maxDate,
    ...rest
  } = props;

  /** 🔹 Convert moment/string to Date if needed (preserves old behavior) */
  const parsedValue =
    value instanceof Date ? value : value ? new Date(value) : null;

  /** 🔹 Handle change event (mimics old KeyboardDatePicker event structure) */
  const handleDateChange = (newValue) => {
    if (typeof onChange === 'function') {
      if (rest.name || rest.id) {
        const event = {
          target: {
            id: rest.id || rest.name,
            value: newValue,
          },
        };
        onChange(event);
      } else {
        onChange(newValue);
      }
    }
  };

  /** 🔹 Extracted slotProps for cleaner JSX */
  const getSlotProps = () => ({
    textField: {
      variant: variant === 'inline' ? 'outlined' : variant,
      margin,
      fullWidth,
      required,
      error,
      helperText,
      InputLabelProps: { shrink: !!value },
      InputProps: {
        ...KeyboardButtonProps, // preserve keyboard icon props
      },
    },
  });

  /** 🔹 Extracted renderInput to a helper for better readability */
  const renderDateInput = (params) => <TextField {...params} />;

  return (
    <DatePicker
      label={label}
      value={parsedValue}
      onChange={handleDateChange}
      format={format || 'dd/MM/yyyy'}
      minDate={minDate}
      maxDate={maxDate}
      slotProps={getSlotProps()}
      renderInput={renderDateInput}
      {...rest}
    />
  );
};

KeyboardDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  format: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  margin: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  KeyboardButtonProps: PropTypes.object,
  disableToolbar: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
};

export default KeyboardDatePicker;
